import TagManager from 'react-gtm-module';

export const useFooterContactUsTag = () =>
  TagManager.dataLayer({
    dataLayer: {
      event: 'click_contact_us',
      category: 'UI Interaction',
      action: 'Click',
      label: 'Contact Us'
    }
  });

export const useFooterTextUsTag = () =>
  TagManager.dataLayer({
    dataLayer: {
      event: 'click_text_us',
      category: 'UI Interaction',
      action: 'Click',
      label: 'Text Us'
    }
  });
